var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperator1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2rem",
    height: "1.2rem",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1E899",
    d: "M19 2h-8v2H9v2h2V4h8v2h2V4h-2zm-8 6h2v2h-2zm6 0V6h-4v2zm0 0h2v2h-2zm-1 2h-2v2H2v10h20V12h-6zm4 4v6H4v-6zm-2 2h-2v2h2zm-6 0h2v2h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator1);
export default __webpack_public_path__ + "static/media/operator1.343c5e57888c5823ea2f7451dfdc4890.svg";
export { ForwardRef as ReactComponent };